import { render, staticRenderFns } from "./ListCompaniesPage.vue?vue&type=template&id=243bdfc2&scoped=true"
import script from "./ListCompaniesPage.vue?vue&type=script&lang=js"
export * from "./ListCompaniesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243bdfc2",
  null
  
)

export default component.exports